import { Component, inject, Input, OnInit } from '@angular/core';
import { IProduct } from '../../../../../IProduct';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { FunctionParametersSettingsClockScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-settings-clock-screen/function-parameters-settings-clock-screen.component';
import { FunctionParametersSettingClockWeekScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-setting-clock-week-screen/function-parameters-setting-clock-week-screen.component';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { FunctionParametersSettingsClockWpComponent } from '../../../Component/function-parameters-settings-clock-wp/function-parameters-settings-clock-wp.component';
import { FunctionParametersSettingClockWeekWpComponent } from '../../../Component/function-parameters-setting-clock-week-wp/function-parameters-setting-clock-week-wp.component';
import { TwoChoicesControlComponent } from '../../../../../../../../components/ecosystems/two-choices-control/two-choices-control.component';
import { TranslatePipe } from '@ngx-translate/core';
import { LargedLinkComponent } from '../../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';
import { LabelConfigurationComponent } from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { P00061FonctionnementPAC } from '../../../Enum/P00061FonctionnementPAC';
import { P00061ModeSilence } from '../../../Enum/P00061ModeSilence';
import { P00061FonctionnementCompresseur } from '../../../Enum/P00061FonctionnementCompresseur';
import { SwitchConfigurationComponent } from '../../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';

@Component({
  selector: 'app-p00061-chauffage-parameters',
  templateUrl: './p00061-chauffage-parameters.component.html',
  styleUrls: ['./p00061-chauffage-parameters.component.scss'],
  imports: [
    TwoChoicesControlComponent,
    TranslatePipe,
    LargedLinkComponent,
    LabelDescriptionComponent,
    LabelConfigurationComponent,
    SwitchConfigurationComponent,
  ],
})
export class P00061ChauffageParametersComponent implements OnInit {
  @Input() productClass: IProduct | null = null;

  private slideModalService: SlideModalController =
    inject(SlideModalController);

  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);

  public actionStack: DeviceActionStackService | null = null;

  constructor() {}

  async goToFunctionParametersSettingsClockScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingsClockWpComponent,
      componentProps: {
        value: [
          this.actionStack!.getValue('wpPHorlogeJourLundi'),
          this.actionStack!.getValue('wpPHorlogeJourMardi'),
          this.actionStack!.getValue('wpPHorlogeJourMercredi'),
          this.actionStack!.getValue('wpPHorlogeJourJeudi'),
          this.actionStack!.getValue('wpPHorlogeJourVendredi'),
          this.actionStack!.getValue('wpPHorlogeJourSamedi'),
          this.actionStack!.getValue('wpPHorlogeJourDimanche'),
        ],
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;

      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACWP_Parametrage3,
        'wpPHorlogeJourLundi',
        hj[0],
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACWP_Parametrage4,
        'wpPHorlogeJourMardi',
        hj[1],
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACWP_Parametrage5,
        'wpPHorlogeJourMercredi',
        hj[2],
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACWP_Parametrage6,
        'wpPHorlogeJourJeudi',
        hj[3],
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACWP_Parametrage7,
        'wpPHorlogeJourVendredi',
        hj[4],
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACWP_Parametrage8,
        'wpPHorlogeJourSamedi',
        hj[5],
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACWP_Parametrage9,
        'wpPHorlogeJourDimanche',
        hj[6],
      );
      this.actionStack!.commit();
    }
  }

  async goToFunctionParametersSettingClockWeekScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingClockWeekWpComponent,
      componentProps: {
        value: this.actionStack!.getValue('wpPHorlogeSemaine'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACWP_Parametrage2,
        'wpPHorlogeSemaine',
        hj,
      );
      this.actionStack!.commit();
    }
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P00061FonctionnementPAC = P00061FonctionnementPAC;
  protected readonly P00061ModeSilence = P00061ModeSilence;
  protected readonly P00061FonctionnementCompresseur =
    P00061FonctionnementCompresseur;
}
